import { memo, useEffect } from 'react';
import { Screen, useNavigation } from '@bonanza-social/navigation';
import AccountMFA from '../components/AccountMFA/AccountMFA';
import { useTranslation } from '@bonanza-social/i18n';

function AccountMFAScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('account');

  useEffect(() => {
    navigation.setOptions({ title: t('accountMFATitle') });
  }, [navigation, t]);

  return (
    <Screen>
      <AccountMFA />
    </Screen>
  );
}

export default memo(AccountMFAScreen);
